import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PlayCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import TutorialVideo from './TutorialVideo';
import useTutorials from '../hooks/useTutorials';

const pathOf = (p) => (p || '').split(/[?#]/)[0].replace(/\/+$/, '') || '/';

// Small "Voir le tutoriel" pill at the top of a page that has a published Reel.
export const TutorialPill = () => {
  const { pathname } = useLocation();
  const items = useTutorials();
  const [open, setOpen] = useState(false);
  const match = (items || []).find((t) => t.feature_path && pathOf(t.feature_path) === pathOf(pathname));
  if (!match || pathOf(pathname) === '/tutoriels') return null;

  return (
    <div className="max-w-7xl mx-auto px-4 pt-4" data-testid="tutorial-pill-wrap">
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 text-orange-700 hover:bg-orange-100 px-4 py-1.5 text-xs font-semibold transition-colors animate-in fade-in slide-in-from-top-1 duration-300"
        data-testid="tutorial-pill"
      >
        <PlayCircle className="h-4 w-4" />
        Voir le tutoriel
        <span className="hidden sm:inline text-orange-500 font-medium">· {match.title}</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="tutorial-pill-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">{match.title}</DialogTitle>
          </DialogHeader>
          <div className="flex justify-center">
            <TutorialVideo item={match} />
          </div>
          {match.description && <p className="text-sm text-stone-600">{match.description}</p>}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TutorialPill;
